export default "__VITE_ASSET__bayGBdQA__"